/* update Process Request Status */
import Axios from './Axios';
import { LOCAL_URL, API_REQUESTS, AUTH_SERVICE_URL } from '../helper/constant'

class RequestDetail extends Axios {

  static async updateProcessRequestDetails(payload) {
    try {
      const UPDATE_REQUEST = `${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/updateRequestDetails`
      const updateRequest = await this.axios.post(UPDATE_REQUEST, payload);
      if (updateRequest && updateRequest.data) {
        return updateRequest.data.data
      }
    } catch (exception) {
      throw JSON.stringify({ message: exception.message })
    }
  }

  /* On reject Request Status */
  static async rejectRequestStatus(payload) {
    return new Promise((resolve, reject) => {
      const REJECT_REQ_STATUS_URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/rejectStatus`
      this.axios.post(REJECT_REQ_STATUS_URL, payload).then((rejectedInfo) => {
        return resolve(rejectedInfo.data)
      })
        .catch(err => {
          return reject(err)
        })
    })
  }


  static async getAddressCollections(params) {
    try {
      const URL = `${AUTH_SERVICE_URL}/collectionaddress/listPortalCollections`;
      const { data } = await this.axios.get(URL, { params: params });
      return data
    } catch (exception) {
      return exception;
    }
  }

  static async deleteAddressCollection(payload, callback) {
    const URL = `${AUTH_SERVICE_URL}/collectionaddress/deleteCollectionAddress`;
    const { siteId, clientId, portalId } = payload;
    const result = await this.axios.post(URL, {
      siteId,
      clientId,
      portalId
    });
    callback();
    return result;
  }

  static async getAddressCollectionBySiteId(params) {
    try {
      const URL = `${AUTH_SERVICE_URL}/collectionaddress/getCollectionBySite`;
      const { data } = await this.axios.get(URL, {params});
      return data

    } catch (exception) {
      return exception;
    }
  }

  static async addAddressCollection(payload) {
    const URL = `${AUTH_SERVICE_URL}/collectionaddress/addCollectionAddress`;
    const result = await this.axios.post(URL, payload);
    return result;
  }

  static async updateAddressCollection(payload) {
    const URL = `${AUTH_SERVICE_URL}/collectionaddress/updateCollectionAddress`;
    const result = await this.axios.post(URL, payload);
    return result;
  }


  static async listProgramRequestStages(payload) {
    return new Promise(async (resolve, reject) => {
      const { portalId, requestTypeId } = payload
      if (!portalId || !requestTypeId) {
        return
      }
      const URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_STAGES}/listRequestStages`
      // let URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_STAGES}/listRequestStages`
      // if(payload.isRequestSubmitted) {
      //   URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_WITH_REQUEST_STAGES}/listRequestStages`
      // }
      // const 
      this.axios.get(URL, { params: payload }).then((response) => {
        if (response.data && response.data.data) {
          return resolve(response.data.data)
        } else {
          return reject({ message: `Portal Request Stages is not found`, })
        }
      })
        .catch(error => {
          return reject(error)
        })
    })
  }

  static listPortalStageStatuses(payload) {
    return new Promise((resolve, reject) => {
      const { portalId } = payload
      if (!portalId) {
        return reject({ message: `Please Provide Proper Portal Information ` })
      }
      const PORTAL_STAGE_URL = `${LOCAL_URL}${API_REQUESTS.PROGRAM_REQUEST_STAGE_STATUS}/listPortalStageStatus`
      this.axios.get(PORTAL_STAGE_URL, {params: payload})
        .then((stageStatusData) => {
          if (stageStatusData.data) {
            return resolve(stageStatusData.data.data)
          }

        })
        .catch(error => {
          return reject(error)
        })
    })
  }

  static async getrequestAddress(payload) {
    try {
      const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_ADDRESS}/getLocationAddress`
      const { data } = await this.axios.post(URL, payload);
      return data.data
    } catch (exception) {
      return exception;
    }
  }

  static async addNewAddress(payload) {
    return new Promise(async (resolve, reject) => {
      const { portalId, clientId, siteId } = payload
      if (!portalId || !clientId || !siteId) {
        return
      }
      const URL = `${LOCAL_URL}${API_REQUESTS.REQUEST_ADDRESS}`
      this.axios.post(URL, payload).then((response) => {
        if (response && response.data) {
          return resolve(response.data)
        } else {
          return reject({ message: `Address Not Correct`, })
        }
      })
        .catch(error => {
          return reject(error)
        })
    })
  }

  static async getAllProcessExcel(filter) {
    try {
      let PROCESS_DATA_LIST = `${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/fetchRequestDetailsListExcel`
      const processList = await this.axios.post(PROCESS_DATA_LIST,filter, { responseType: 'blob' });
      return processList && processList.data
    } catch (exception) {
      throw JSON.stringify(exception)
    }
  }

  static async getKPIRequestsExcel(filter) {
    try {
      let PROCESS_DATA_LIST = `${LOCAL_URL}${API_REQUESTS.REQUEST_DETAILS}/exportKPIRequests`
      const processList = await this.axios.post(PROCESS_DATA_LIST,filter, { responseType: 'blob' });
      return processList && processList.data
    } catch (exception) {
      throw JSON.stringify(exception)
    }
  }


}
export default RequestDetail;